/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Group_Sync_Property_Timing_HelpInputs */



/**
* | output |
* | --- |
* | "Start and end timecodes" |
*
* @param {Event_Group_Sync_Property_Timing_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_group_sync_property_timing_help = /** @type {((inputs?: Event_Group_Sync_Property_Timing_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Group_Sync_Property_Timing_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Start and end timecodes")
	if (locale === "de") return /** @type {LocalizedString} */ ("Start and end timecodes")
	if (locale === "it") return /** @type {LocalizedString} */ ("Start and end timecodes")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Start and end timecodes")
	if (locale === "es") return /** @type {LocalizedString} */ ("Start and end timecodes")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Start and end timecodes")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Start and end timecodes")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Start and end timecodes")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Start and end timecodes")
	return /** @type {LocalizedString} */ ("Start and end timecodes")
});